// extracted by mini-css-extract-plugin
export default {"tabs_content":"index_tabs_content_pCdhL","tabs_box":"index_tabs_box_HyfuU","tabs":"index_tabs_zUaxR","mask":"index_mask_8JZkA"};